import React from 'react';
import { useIntl } from 'react-intl';

import PriceTagSvg from './price-tag.svg';

const FreeGiftTag: React.FC = () => {
  const { formatMessage } = useIntl();

  const message = formatMessage({
    id: 'GlobalComponents.FreeGiftTag.Text',
  });

  return (
    <div
      className="r-flex r-items-center r-gap-1 
              r-bg-[#727272] r-text-white
                r-text-sm r-font-bold 
                r-py-1 r-px-2 r-rounded-md r-w-max"
      data-testid="free-gift-tag"
    >
      <PriceTagSvg className="r-fill-white r-w-5 r-h-5" />
      <span>{message}</span>
    </div>
  );
};

export default FreeGiftTag;
